import { Wrapper } from './SummaryInset.styled';

export const SummaryInset = ({ children }: { children: React.ReactNode }) => (
  <Wrapper>{children}</Wrapper>
);
